import type { CalibrationStep } from './types';

export const CALIBRATION_STEPS: CalibrationStep[] = [
  {
    id: 'noise',
    kind: 'noise',
    label: 'Stay quiet and keep still.',
    prepMs: 2200,
    durationMs: 1800,
  },
  {
    id: 'single-c4-soft',
    kind: 'single',
    label: 'Play middle C softly and hold it.',
    prepMs: 2400,
    expectedMidi: [60],
    promptMidi: [60],
    promptVelocity: 0.45,
    durationMs: 2100,
  },
  {
    id: 'single-c4-loud',
    kind: 'single',
    label: 'Play middle C loudly and hold it.',
    prepMs: 2600,
    expectedMidi: [60],
    promptMidi: [60],
    promptVelocity: 0.82,
    durationMs: 2200,
  },
  {
    id: 'single-low',
    kind: 'single',
    label: 'Play one lower note and hold it.',
    prepMs: 2200,
    promptMidi: [48],
    midiRange: [36, 59],
    durationMs: 2100,
  },
  {
    id: 'single-mid',
    kind: 'single',
    label: 'Play one middle-register note other than middle C.',
    prepMs: 2200,
    promptMidi: [67],
    midiRange: [55, 72],
    durationMs: 2100,
  },
  {
    id: 'single-high',
    kind: 'single',
    label: 'Play one higher note and hold it.',
    prepMs: 2200,
    promptMidi: [79],
    midiRange: [72, 96],
    durationMs: 2100,
  },
  {
    id: 'chord-close',
    kind: 'chord',
    label: 'Play a close 2-note interval or triad.',
    prepMs: 2400,
    promptMidi: [60, 64, 67],
    minDistinctMidis: 2,
    durationMs: 2300,
  },
  {
    id: 'chord-wide',
    kind: 'chord',
    label: 'Play a wider interval or chord.',
    prepMs: 2400,
    promptMidi: [48, 60, 72],
    minDistinctMidis: 2,
    durationMs: 2300,
  },
];
